import { axiosInstance } from '../context/AuthContext';

export const purchaseHistoryApi = {
  getPurchaseHistory: async () => {
    const response = await axiosInstance.get('/user/purchase-history/');
    return response.data;
  },

  getPurchaseStats: async () => {
    const response = await axiosInstance.get('/user/purchase-history/stats/summary');
    return response.data;
  },
};
